import { useState } from 'react'
import classNames from 'classnames'
import { toast, resolveValue, type Toast } from 'react-hot-toast'
import { Close } from '../icons/Close'
import { PushPin } from '../icons/PushPin'
import { useTranslationTyped } from 'i18n/i18n'

function getToastFn(type: Toast['type']) {
  switch (type) {
    case 'success':
      return toast.success
    case 'error':
      return toast.error
    default:
      return toast
  }
}

export function ToastItem({ t }: { t: Toast }) {
  const [pinned, setPinned] = useState(false)
  const { tt } = useTranslationTyped()

  let colorClassName: string
  if (t.type === 'error') {
    colorClassName = 'bg-core-error text-core-on-error'
  } else if (t.type === 'success') {
    colorClassName = 'bg-core-success text-core-on-success'
  } else {
    colorClassName = 'bg-on-surface-var text-core-on-primary'
  }

  const handlePin = () => {
    setPinned(true)
    const toastFn = getToastFn(t.type)
    toastFn(t.message, {
      id: t.id,
      duration: Infinity,
      className: t.className,
    })
  }

  const handleDismiss = () => {
    toast.dismiss(t.id)
  }

  return (
    <div
      role="alert"
      className={classNames(
        'w-full',
        colorClassName,
        t.visible ? 'animate-toast-enter' : 'animate-toast-leave'
      )}
    >
      <div
        className={classNames(
          'flex max-h-screen items-center gap-1 p-4',
          t.className
        )}
      >
        <div className="flex-1">{resolveValue(t.message, t)}</div>
        {!pinned && t.duration !== Infinity && (
          <button
            type="button"
            className="shrink-0 rounded p-1 opacity-70 hover:opacity-100 focus:opacity-100 focus:outline-none focus:ring-2 focus:ring-white"
            onClick={handlePin}
            aria-label={tt.common.do_not_auto_close()}
          >
            <PushPin size={18} />
          </button>
        )}
        <button
          type="button"
          className="shrink-0 rounded p-1 opacity-70 hover:opacity-100 focus:opacity-100 focus:outline-none focus:ring-2 focus:ring-white"
          onClick={handleDismiss}
          aria-label={tt.common.close()}
        >
          <Close size={18} />
        </button>
      </div>
    </div>
  )
}
